import axios from "axios";
import { tokenStorage } from "@/utils/storage";
import appConfig from "../config";
import { jwt } from "./jwt";

const api = axios.create({
  baseURL: appConfig.api_url,
});

api.interceptors.request.use(
  async (config) => {
    const token = tokenStorage.getItem();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.locale = "en";
    config.headers["Accept-Language"] = "en";

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const { response } = error;

    const originalRequest = error.config;

    if (response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await jwt.refreshToken();

        if (newToken) {
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

          return api(originalRequest);
        }

        return Promise.reject();
      } catch (refreshError) {
        // Handle failure (e.g., redirect to login)
        return Promise.reject(refreshError);
      }
    }

    if (response?.status === 401) {
      // TODO: improve
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export { api };
